import type { SVGProps } from 'react';

/** Figma `cup-music.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const CupMusicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.24"
      d="M15.0002 20C7.80027 20 6.52479 12.8244 6.29884 7.13309C6.23599 5.54997 6.20456 4.75841 6.79921 4.02604C7.39385 3.29367 8.10556 3.17359 9.52897 2.93343C10.9341 2.69636 12.7708 2.5 15.0002 2.5C17.2296 2.5 19.0663 2.69636 20.4714 2.93343C21.8948 3.17359 22.6065 3.29367 23.2012 4.02604C23.7958 4.75841 23.7644 5.54997 23.7015 7.13309C23.4756 12.8244 22.2001 20 15.0002 20Z"
      fill="#007AFF"
    />
    <path
      d="M22.0504 15.5275L25.5711 13.5716C26.5116 13.049 26.9819 12.7878 27.2409 12.3476C27.4999 11.9075 27.4999 11.3695 27.4999 10.2936L27.4999 10.2029C27.5 8.89841 27.5 8.24616 27.1461 7.7551C26.7921 7.26404 26.1733 7.05778 24.9358 6.64526L23.75 6.25L23.7288 6.3558C23.723 6.59239 23.7128 6.85008 23.7015 7.13307C23.5912 9.91356 23.2303 13.0483 22.0504 15.5275Z"
      fill="#007AFF"
    />
    <path
      d="M6.29884 7.13309C6.40923 9.9137 6.77015 13.0486 7.9501 15.5279L4.42881 13.5716C3.48829 13.049 3.01802 12.7878 2.75903 12.3476C2.50005 11.9075 2.50003 11.3695 2.5 10.2936L2.5 10.2029C2.49997 8.89842 2.49995 8.24615 2.85387 7.7551C3.20779 7.26404 3.82658 7.05778 5.06415 6.64526L6.24993 6.25L6.2716 6.35838C6.27745 6.59427 6.28764 6.85112 6.29884 7.13309Z"
      fill="#007AFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5625 27.5C6.5625 26.9822 6.98223 26.5625 7.5 26.5625H22.5C23.0178 26.5625 23.4375 26.9822 23.4375 27.5C23.4375 28.0178 23.0178 28.4375 22.5 28.4375H7.5C6.98223 28.4375 6.5625 28.0178 6.5625 27.5Z"
      fill="#007AFF"
    />
    <path
      opacity="0.24"
      d="M19.3221 26.5632H10.6781L11.0491 24.3759C11.166 23.7917 11.679 23.3711 12.2748 23.3711H17.7253C18.3212 23.3711 18.8342 23.7917 18.9511 24.3759L19.3221 26.5632Z"
      fill="#007AFF"
    />
    <path
      d="M15.0002 20C14.6757 20 14.3633 19.9854 14.0625 19.957V23.3701H15.9375V19.9571C15.6368 19.9854 15.3245 20 15.0002 20Z"
      fill="#007AFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 5.3125C16.7678 5.3125 17.1875 5.73223 17.1875 6.25C17.1875 7.11295 17.8871 7.8125 18.75 7.8125C19.2678 7.8125 19.6875 8.23223 19.6875 8.75C19.6875 9.26777 19.2678 9.6875 18.75 9.6875C18.1874 9.6875 17.6563 9.55233 17.1875 9.31268V13.125C17.1875 14.6783 15.9283 15.9375 14.375 15.9375C12.8217 15.9375 11.5625 14.6783 11.5625 13.125C11.5625 11.5717 12.8217 10.3125 14.375 10.3125C14.7037 10.3125 15.0193 10.3689 15.3125 10.4725V6.25C15.3125 5.73223 15.7322 5.3125 16.25 5.3125ZM14.375 12.1875C14.8928 12.1875 15.3125 12.6072 15.3125 13.125C15.3125 13.6428 14.8928 14.0625 14.375 14.0625C13.8572 14.0625 13.4375 13.6428 13.4375 13.125C13.4375 12.6072 13.8572 12.1875 14.375 12.1875Z"
      fill="#007AFF"
    />
  </svg>
);
